import { UndergroundLayer } from '../types/underground';
import type { UndergroundMetrics } from '../types/underground';
import type { TickResult } from '../src/domain/types/tickResult';

type UndergroundTickSlice = Pick<UndergroundMetrics, 'complianceBonus' | 'threatReduction'>;

const LAYER_TICK_METRICS: Partial<Record<UndergroundLayer, UndergroundTickSlice>> = {
  [UndergroundLayer.Infrastructure]: { complianceBonus: 0.25, threatReduction: 0.15 },
  [UndergroundLayer.Connectivity]: { complianceBonus: 0.35, threatReduction: 0.2 },
};

/** Metrics used until MultiLayerGrid + UndergroundSimulation are wired in App. */
export function getLayerTickMetrics(layer: UndergroundLayer): UndergroundTickSlice | null {
  if (layer === UndergroundLayer.Surface) return null;
  return LAYER_TICK_METRICS[layer] ?? null;
}

/** Merge UndergroundSimulation.calculateTickMetrics output into a tick result. */
export function mergeUndergroundMetrics(
  result: TickResult,
  metrics: UndergroundTickSlice
): TickResult {
  const { complianceBonus, threatReduction } = metrics;
  return {
    ...result,
    netComp: result.netComp + complianceBonus,
    dailyThreat: result.dailyThreat - threatReduction,
    deltas: {
      ...result.deltas,
      compliance: result.deltas.compliance + complianceBonus,
      threat: result.deltas.threat - threatReduction,
    },
  };
}

/** Apply underground layer bonus — uses mergeUndergroundMetrics when layer is active. */
export function applyActiveLayerTickBonus(
  result: TickResult,
  layer: UndergroundLayer
): TickResult {
  const metrics = getLayerTickMetrics(layer);
  if (!metrics) return result;
  return mergeUndergroundMetrics(result, metrics);
}